import React from 'react';
import FilterBar from './FilterBar';
import ViewToggle, { ViewMode } from './ViewToggle';
import { ExtendedTaskFilter } from '../types/Task';
import './ControlsSection.css';

interface ControlsSectionProps {
  filter: ExtendedTaskFilter;
  onFilterChange: (filter: ExtendedTaskFilter) => void;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  availableOwners?: string[];
  availableReporters?: string[];
  availableLabels?: string[];
  availableStatuses?: string[];
  filteredCount?: number;
  totalCount?: number;
}

const ControlsSection: React.FC<ControlsSectionProps> = ({
  filter,
  onFilterChange,
  viewMode,
  onViewModeChange,
  availableOwners,
  availableReporters,
  availableLabels,
  availableStatuses,
  filteredCount,
  totalCount,
}) => {
  return (
    <div className="controls-section">
      <div className="controls-section-header">
        <h2>Task Management</h2>
        <ViewToggle currentView={viewMode} onViewChange={onViewModeChange} />
      </div>
      
      <div className="controls-section-content">
        <FilterBar
          filter={filter}
          onFilterChange={onFilterChange}
          availableOwners={availableOwners}
          availableReporters={availableReporters}
          availableLabels={availableLabels}
          availableStatuses={availableStatuses}
          filteredCount={filteredCount}
          totalCount={totalCount}
        />
      </div>
    </div>
  );
};

export default ControlsSection; 